"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APRadio = _interopRequireDefault(require("../../../../common/APRadio/APRadio"));
var _APNumberInput = _interopRequireDefault(require("../../../../common/APNumberInput"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var EotcBuySellCustomRowComponent = /*#__PURE__*/function (_React$Component) {
  function EotcBuySellCustomRowComponent() {
    _classCallCheck(this, EotcBuySellCustomRowComponent);
    return _callSuper(this, EotcBuySellCustomRowComponent, arguments);
  }
  _inherits(EotcBuySellCustomRowComponent, _React$Component);
  return _createClass(EotcBuySellCustomRowComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        synchronizePriceWithQuantity = _this$props.synchronizePriceWithQuantity,
        setAmount = _this$props.setAmount,
        activeAmount = _this$props.activeAmount,
        isBuySide = _this$props.isBuySide,
        formObj = _this$props.formObj,
        themeModifier = _this$props.themeModifier,
        customValues = _this$props.customValues,
        decimalPlaces = _this$props.decimalPlaces,
        selectedInstrument = _this$props.selectedInstrument,
        baseClasses = _this$props.baseClasses;
      var arrow = /*#__PURE__*/_react["default"].createElement("p", {
        className: baseClasses('arrow')
      }, !isBuySide ? '→' : '←');
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('amount-row', 'one-input-layout'),
        onClick: function onClick() {
          return setAmount('custom');
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('first-in-row')
      }, /*#__PURE__*/_react["default"].createElement(_APRadio["default"], {
        name: "amountRadio",
        id: 'custom',
        value: 'custom'
      })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_APNumberInput["default"], {
        name: "quantity",
        customClass: baseClasses(),
        classModifiers: "".concat(activeAmount === 'custom' ? 'active' : 'disable', " ").concat(themeModifier),
        decimalPlaces: decimalPlaces[selectedInstrument.Product1Symbol],
        customChange: function customChange(value) {
          synchronizePriceWithQuantity(value, 'buySell', 'price', formObj);
        }
      })), arrow, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('last-in-row')
      }, customValues && customValues.pricePerUnit ? customValues.pricePerUnit : '-'));
    }
  }]);
}(_react["default"].Component);
EotcBuySellCustomRowComponent.propTypes = {
  isBuySide: _propTypes["default"].bool.isRequired,
  formObj: _propTypes["default"].object.isRequired,
  customValues: _propTypes["default"].object,
  synchronizePriceWithQuantity: _propTypes["default"].func.isRequired,
  selectedInstrument: _propTypes["default"].object.isRequired,
  decimalPlaces: _propTypes["default"].object.isRequired,
  themeModifier: _propTypes["default"].string
};
var _default = exports["default"] = EotcBuySellCustomRowComponent;